module.exports = __webpack_public_path__ + "static/media/background-fog-b.796c1edf.png";